// extracted by mini-css-extract-plugin
export default {"l_TextareaViewDiv_main":"TextareaViewDiv_l_TextareaViewDiv_main__v1LV4","l_TextareaViewDiv_pre":"TextareaViewDiv_l_TextareaViewDiv_pre__l0+bg"};